export default __webpack_public_path__ + "static/media/monibrand-logo-collapsed.a6fc6517.svg";